export default "__VITE_ASSET__e1iZc3Dp__"